import {clearString, getAlphabet, keyedAlphabet} from "@/components/cyphers/helpers/stringHelpers";
import HebrewMethods from "./hebrew"
const SEPARATOR = ''
export const methods = {
    cypher: function (input, hasCh = true, missing = [], params, sep = SEPARATOR) {
        let key = (params[1]||"").replaceAll(/[^a-zA-Z]/gm, '');
        // if(!key){
        //     return HebrewMethods.cypher(input, hasCh, missing, params, sep)
        // }
        let cyphered = []
        let cleared = clearString(input, hasCh)//
        missing.forEach((char) => {
            if (char !== 'ch')
                cleared = cleared.replaceAll(char, '')
        })
        let characters = cleared.split('');
        for (let i = 0; i < characters.length; i++) {
            let char = characters[i];
            if (char.match(/[.,?! ]/)) {
                cyphered.push(-1);
            } else {
                cyphered.push(keyedAlphabet(key,hasCh).indexOf(char));
            }
        }
        return cyphered//.join(sep).replaceAll('*', 'ch')
    },
    decypher: function (input, hasCh = false, missing = [], params) {
        return null
    },
};

export default {...methods,SEPARATOR}